import React, { ReactNode } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { ButtonsAlignment } from '@hospitalrun/components/dist/components/Modal/interfaces'
import { Props as ButtonProps } from '@hospitalrun/components'

import classes from '../../style.module.scss'
import { ReactSVG } from 'react-svg'
import Close from '../../icons/close.svg'
import './newModal.scss'
import { ComponentWrapperWithAITracking } from 'analytics/AppInsights'
import AnalyticsWrapper from 'analytics/AnalyticsWrapper'
import ButtonAnalyticsAntd from 'analytics/ButtonAnalyticsAntd'
interface Props {
  show: boolean
  title: string
  body?: ReactNode
  showHeaderCloseButton?: boolean
  verticallyCentered?: boolean
  buttonsAlignment?: ButtonsAlignment
  closeButton?: ButtonProps
  middleButton?: ButtonProps
  successButton?: ButtonProps
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  blockScroll?: boolean
  className?: string
}

const NewModal = (props: Props) => {
  const {
    show,
    title,
    body,
    closeButton,
    middleButton,
    successButton,
    maxWidth,
    blockScroll,
    className,
  } = props

  return (
    <div style={{ borderWidth: 2, borderColor: '#D8DEE9' }}>
      <Dialog
        maxWidth={maxWidth ? maxWidth : undefined}
        fullWidth
        open={show}
        onClose={closeButton && closeButton.onClick}
        className={
          `dialog ${blockScroll ? 'blockScroll' : ''} ` + ' ' + (className ? className : '')
        }
      >
        <DialogTitle style={{ padding: 0 }} id="scroll-dialog-title">
          <div className={classes.panel_top_modal}>
            <div style={{ width: '80%' }}>{title}</div>
            <div style={{ width: '18%', display: 'flex', justifyContent: 'flex-end' }}>
              {closeButton && (
                <AnalyticsWrapper keyAnalytics={`${title} modal close button`}>
                  <ReactSVG
                    style={{ cursor: 'pointer', width: 'fillContent' }}
                    onClick={closeButton && closeButton.onClick}
                    src={Close}
                  />
                </AnalyticsWrapper>
              )}
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="dialog_content">
          <div
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '100%',
            }}
          >
            <div className={classes.middle_wrapper}>
              <div className={classes.panel_bottom}>
                {body}
                {(middleButton || successButton) && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                      marginTop: '10px',
                      marginBottom: '10px',
                      gap: '16px',
                    }}
                  >
                    {middleButton && (
                      <AnalyticsWrapper keyAnalytics={`${title} modal middle button`}>
                        <ButtonAnalyticsAntd buttonType="dashed" onClick={middleButton.onClick}>
                          {middleButton.children}
                        </ButtonAnalyticsAntd>
                      </AnalyticsWrapper>
                    )}

                    {successButton && (
                      <AnalyticsWrapper keyAnalytics={`${title} modal success button`}>
                        <ButtonAnalyticsAntd
                          disabled={successButton?.disabled}
                          buttonType="primary"
                          onClick={successButton.onClick}
                        >
                          {successButton.children}
                        </ButtonAnalyticsAntd>
                      </AnalyticsWrapper>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default ComponentWrapperWithAITracking(NewModal, 'NewModal')
